import { Locale, K } from "../constants";

const locale: Locale = {
  [K.CRONTAB]: "Crontab",
  [K.OR_MONTHLY]: "或者每月的",
};

export default locale;
